"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class BandcampPlayer extends _react.Component {
  getSrc() {
    const {
      src,
      size,
      merch,
      tracklist,
      artwork,
    } = this.props;
    const sizeString = size ? `size=${size}` : '';
    const merchString = merch ? `/package=${merch}` : '';
    const tracklistString = tracklist ? `/tracklist=${tracklist}` : '/tracklist=false';
    const artworkString = artwork ? `/artwork=${artwork}` : '';
    return `${src}${sizeString}${merchString}${tracklistString}${artworkString}/`;
  }

  getStyles() {
    const {
      height,
      width
    } = this.props;
    return {
      border: 0,
      width,
      height
    };
  }

  render() {
    const {
      title
    } = this.props;
    const style = this.getStyles();
    const src = this.getSrc();
    return /*#__PURE__*/_react.default.createElement("iframe", {
      title: title,
      style: style,
      className: "BandcampPlayer",
      src: src,
      seamless: true
    });
  }

}

BandcampPlayer.propTypes = {
  album: _propTypes.default.string,
  size: _propTypes.default.string,
  bgcol: _propTypes.default.string,
  linkcol: _propTypes.default.string,
  merch: _propTypes.default.string,
  tracklist: _propTypes.default.string,
  artwork: _propTypes.default.string,
  title: _propTypes.default.string
};
BandcampPlayer.defaultProps = {
  size: 'large',
  bgcol: 'ffffff',
  linkcol: '0687f5',
  merch: null,
  tracklist: false,
  artwork: 'big',
  title: 'Bandcamp player'
};
var _default = BandcampPlayer;
exports.default = _default;
